import swal from "sweetalert2/dist/sweetalert2.js";

var boardGame = {
  valueToImage: function(value) {
    var img = "";
    switch (value) {
      case "ileri":
        img = "ileri.png";
        break;
      case "sag":
        img = "sag.png";
        break;
      case "sol":
        img = "sol.png";
        break;
      case "esit":
        img = "if_esit.png";
        break;
      case "esit_degil":
        img = "if_esit_degil.png";
        break;
      case "x":
        img = "dongu.png";
        break;
      case "dongu_son":
        img = "dongu_son.png";
        break;
      case "x2":
        img = "dongux2.png";
        break;
      case "x3":
        img = "dongux3.png";
        break;
      case "x4":
        img = "dongux4.png";
        break;
      case "x5":
        img = "dongux5.png";
        break;
      case "kaya":
        img = "kaya.png";
        break;
      case "bos":
        img = "bos.png";
        break;
      case "hr":
        img = "hedefRakip.png";
        break;
      case "hA":
        img = "hedefAyni.png";
        break;
      case "h0":
        img = "hedef0.png";
        break;
      case "h1":
        img = "hedef1.png";
        break;
      case "h2":
        img = "hedef2.png";
        break;
      case "h3":
        img = "hedef3.png";
        break;
      case "h4":
        img = "hedef4.png";
        break;
      case "h5":
        img = "hedef5.png";
        break;
      case "tospaa":
        img = "tospaa.png";
        break;
      default:
        return "";
    }
    return "images/" + img;
  },

  whatIsNext: function(tospaaRotation, tospaaIndex, map) {
    switch (tospaaRotation) {
      case 0: //NORTH
        if (tospaaIndex >= 8) return map[tospaaIndex - 8];
        break;
      case 90: //EAST
        if (tospaaIndex <= 62 && tospaaIndex % 8 < 7) return map[tospaaIndex + 1];
        break;
      case 180: //SOUTH
        if (tospaaIndex <= 55) return map[tospaaIndex + 8];
        break;
      case 270: //WEST
        if (tospaaIndex >= 1 && tospaaIndex % 8 > 0) return map[tospaaIndex - 1];
        break;
    }
    return undefined;
  },

  isGoable: function(tospaaRotation, tospaaIndex, map) {
    switch (tospaaRotation) {
      case 0: //NORTH
        if (Math.floor(tospaaIndex / 8) === 0) return false;
        break;
      case 90: //EAST
        if (tospaaIndex % 8 === 7) return false;
        break;
      case 180: //SOUTH
        if (Math.floor(tospaaIndex / 8) === 7) return false;
        break;
      case 270: //WEST
        if (tospaaIndex % 8 === 0) return false;
        break;
    }
    if (this.whatIsNext(tospaaRotation, tospaaIndex, map) === "kaya") {
      return false;
    }
    return true;
  },

  analyseCode: function(codes) {
    var directions = ["ileri", "sag", "sol"];
    var decisions = ["esit", "esit_degil"];
    var barriers = ["kaya", "bos"];

    var loopCount = 0;
    var totalScore = 0;

    for (var i = 0; i < codes.length; i++) {
      var action = codes[i];
      if (directions.includes(action)) {
        totalScore++;
      }
      if (action === "" || action === undefined) continue;
      if (i % 4 == 0) {
        if (action.startsWith("x")) loopCount++;
        if (action === "dongu_son") loopCount--;
        if (loopCount < 0) {
          swal.fire("Kodunu kontrol etmelisin!", "Hatalı yerde kapatılmış bir döngü var!", "warning");
          return -100 - i;
        }
        if (decisions.includes(action)) {
          if (!barriers.includes(codes[i + 1])) {
            swal.fire("Kodunu kontrol etmelisin!", "Hatalı koşul ifadesi! Koşul belirtilmemiş", "warning");
            return -100 - i;
          }
        }
      } else {
        if (i % 4 == 1) {
          if (barriers.includes(action)) {
            if (decisions.includes(codes[i - 1])) {
              continue;
            }
          }
        }
        if (i % 4 == 2 || i % 4 == 3) {
          if (directions.includes(action)) {
            var k = i % 4;
            if (decisions.includes(codes[i - k])) {
              continue;
            }
          }
        }
        swal.fire("Kodunu kontrol etmelisin!", "yanlış yerde anlamsız kod", "warning");
        return -100 - i;
      }
    }
    if (loopCount != 0) {
      swal.fire("Kodunu kontrol etmelisin!", "Kapatılmamış bir döngü var!", "warning");
      return -100 - i;
    }
    return totalScore;
  },

  getCodeLastElementIndex: function(codes) {
    let lastElementIndex = -1;
    for (let c = 0; c < codes.length; c++) {
				if(codes[c].length>0) {
					lastElementIndex = c;
				}
    }
    return lastElementIndex;
  },
};

export default boardGame;
